import OrganizationsList from 'pages/admin/organizations/OrganizationsList';
import OrganizationProjects from 'pages/admin/organizations/OrganizationProjects';
import OrganizationUsers from 'pages/admin/organizations/OrganizationUsers';
import OrganizationUsersInvitations from 'pages/admin/organizations/OrganizationUsersInvitations';
import OrganizationData from 'pages/admin/organizations/OrganizationData';
import OrganizationUsersInvite from 'pages/admin/organizations/OrganizationUsersInvite';
import OrganizationUser from 'pages/admin/organizations/OrganizationUser';
import OrganizationCredits from 'pages/admin/organizations/OrganizationCredits';
import Templates from 'pages/admin/Templates/Templates';
import NoMatch from 'pages/NoMatch';
import WipPlaceholder from 'pages/WipPlaceholder';
import InvitationAcceptance from 'pages/auth/InvitationAcceptance';
import Briefing from 'pages/briefing/Briefing';
import BriefingTemplates from 'pages/admin/Templates/BriefingTemplates';
import WorkbenchesList from 'pages/admin/workbenches/WorkbenchesList';
import Workbench from 'pages/admin/workbenches/Workbench';
import ProductsList from 'pages/admin/products/ProductsList';
import Product from 'pages/admin/products/Product';
import Files from 'pages/project/Files';
import ErrorBoundary from 'pages/ErrorBoundary';
import Assets from 'pages/admin/Assets/Assets';

export default {
  OrganizationsList,
  OrganizationProjects,
  Templates,
  NoMatch,
  OrganizationUsers,
  OrganizationUsersInvitations,
  OrganizationUsersInvite,
  OrganizationCredits,
  OrganizationUser,
  OrganizationData,
  WipPlaceholder,
  InvitationAcceptance,
  Briefing,
  BriefingTemplates,
  WorkbenchesList,
  Workbench,
  ProductsList,
  Product,
  ErrorBoundary,
  project: {
    Files,
  },
  Assets,
};
